import React, { useEffect, useState } from "react";
import "./News.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchNews, resetStateNews } from "../../app/slices/newsSlice";
import ManageNewsDialog from "./ManageNewsDialog";

import { Button } from "@mui/material";
import AppDataTable from "../../components/appDataTable/appDataTable";
import ErrorContainer from "../../components/errorContainer/errorContainer";
import LoadingContainer from "../../components/loadingContainer/loadingContainer";
import EmptyDataContainer from "../../components/emptyDataContainer/emptyDataContainer";

const News = () => {
  const { list, status, error } = useSelector(({ news }) => news.get);

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState(null);
  const [data, setData] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const language = localStorage.getItem("currentLanguage")?.toUpperCase();

  const columns = [
    {
      name: "DATE_CREATED",
      label: "Date Posted",
    },
    {
      name: "TITLE",
      label: "Title",
    },
    {
      name: "DESCRIPTION",
      label: "Description",
    },
    {
      name: "STATUS_DISPLAY",
      label: "Status",
    },
  ];

  //use effects
  useEffect(() => {
    dispatch(fetchNews());
  }, [dispatch]);

  useEffect(() => {
    if (list) {
      let _data = [];
      list.forEach((row) => {
        _data.push({
          ...row,
          TITLE: row[`TITLE_${language}`],
          DESCRIPTION: trimDescription(row[`DESCRIPTION_${language}`]),
          STATUS_DISPLAY: translateStatus(row?.STATUS),
        });
      });
      setData(_data);
    }
  }, [list, language]);

  //methods
  const translateStatus = (s) => {
    switch (s) {
      case "A":
        return "Active";
      case "I":
        return "Inactive";
      default:
        return s;
    }
  };

  const trimDescription = (description) => {
    return description?.length > 80
      ? `${description?.substring(0, 79)}...`
      : description;
  };

  //builders
  return (
    <>
      <div className="container-100 mb-20 "></div>
      <div className="flex-row">
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            setAction("POST");
            setOpen(true);
          }}
        >
          Post News
        </Button>
      </div>

      {status === "loading" && (
        <LoadingContainer
          hasBackground={true}
          message="Loading news"
          id="loading-container-news"
        />
      )}

      {error !== null && status !== "loading" && (
        <ErrorContainer
          id="error-container-news"
          hasBackground={true}
          message={error?.message || "An error occurred"}
          onReload={() => {
            dispatch(resetStateNews());
            dispatch(fetchNews());
          }}
        />
      )}

      {status === "idle" && list?.length <= 0 && (
        <EmptyDataContainer
          message="No news found"
          hasBackground={true}
          id="empty-data-news"
        />
      )}

      {data?.length > 0 && error === null && status === "idle" && (
        <AppDataTable
          id="news-list"
          actions={[
            {
              action: "View",
              onClick: (item) => {
                setAction("VIEW");
                setSelectedItem(item);
                setOpen(true);
              },
            },
            {
              action: "Update",
              onClick: (item) => {
                setAction("UPDATE");
                setSelectedItem(item);
                setOpen(true);
              },
            },
          ]}
          // actionIcon={<IconEdit color="secondary" />}
          columns={columns}
          data={data}
          emptyMessage="No news found"
          rowsPerPageOptions={[10, 20, 50, 100]}
          downloadFileName="System Genres"
        />
      )}

      {open && (
        <ManageNewsDialog
          selectedItem={selectedItem}
          open={open}
          action={action}
          handleClose={() => {
            dispatch(fetchNews());
            setSelectedItem(null);
            setOpen(false);
          }}
        />
      )}
    </>
  );
};

export default News;
